import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeTrainings = data => {
  const training = new schema.Entity('trainings')
  return normalize(data, [training])
}

const TrainingsReducer = combineReducers({
  fetchTrainingsRequest: createRequestReducer('TRAININGS:FETCH'),
  filters: createReducer(
    { schoolOrganisation: false },
    {
      'TRAININGS:FILTER_SCHOOL_ORGANISATION': state => ({
        ...state,
        schoolOrganisation: true
      }),
      'TRAININGS:FILTER_ALL': state => ({
        ...state,
        schoolOrganisation: false
      })
    }
  ),
  trainings: createReducer(null, {
    'TRAININGS:FETCH_REQUEST_SUCCESS': (state, { response }) => {
      return normalizeTrainings(response.data.assessment_files)
    }
  })
})

export default TrainingsReducer
